<template>
    <toolbar-option type="stacked">
        <template slot="secondary">
            <dropdown
                :options="typeOptions"
                :value="type"
                native
                @input="onTypeInput"
            />
        </template>

        <template slot="primary">
            <slider
                v-if="type === 'custom'"
                :value="sliderIndex"
                :values="themeObjectValues"
                @input="onInput"
            />
        </template>
    </toolbar-option>
</template>

<script>
import baseOption from '@/options/mixins/base-option-slider';

const DEFAULT_Z_INDEX = 0;

export default {
    name: 'z-index',
    mixins: [baseOption],

    data() {
        return {
            displayName: 'Z Index',
            excludeKeys: ['auto'],
            tailwindDefinitionProp: 'zIndex',
            type: 'auto',

            typeOptions: [
                { text: 'Auto', value: 'auto' },
                { text: 'Custom', value: 'custom' },
            ],
        };
    },

    computed: {
        defaultSliderIndex() {
            return this.themeObjectValues.indexOf(String(DEFAULT_Z_INDEX));
        },
    },

    methods: {
        onTypeInput(typeNew) {
            this.type = typeNew;
            this.sliderIndex = this.defaultSliderIndex;

            if (typeNew === 'custom') {
                this.addFlexClass({ value: this.sliderValue });
            } else {
                this.removeFlexClass();
            }
        },

        onSelectedElement() {
            const { value } = this.flexClassDefinition;

            if (!value || value === 'auto') {
                this.type = 'auto';
                this.sliderIndex = this.defaultSliderIndex;
            } else {
                this.type = 'custom';
                this.setSlider();
            }
        },
    },
};
</script>
